import useSWR from "swr";
import SubscriptionService from "../services/SubscriptionService";

const fetcher = async () => {
    return await SubscriptionService.getAll();
};

/**
 * Hook para obtener la lista de suscripciones sin paginación
 */
const useSubscriptions = () => {
    const { data, error, isLoading, mutate } = useSWR("subscriptions", fetcher);

    return {
        subscriptions: data || [],
        isLoading,
        error,
        mutate,
    };
};

export default useSubscriptions;
